import { create } from 'zustand';

import { USER_ID_SESSION_STORAGE_KEY } from 'constants/session';

interface RegistrationSessionActions {
    userIdAssigned: (userId: string) => void;
    userIdCleared: () => void;
}

interface RegistrationSessionState {
    /** User id of the in-progress signup. Empty string when none. */
    userId: string;
    actions: RegistrationSessionActions;
}

// sessionStorage-backed so an in-progress signup survives a reload within the
// same tab.
const readInitialUserId = (): string => {
    if (typeof window === 'undefined' || typeof window.sessionStorage?.getItem !== 'function') {
        return '';
    }
    return sessionStorage.getItem(USER_ID_SESSION_STORAGE_KEY) ?? '';
};

export const useRegistrationSessionStore = create<RegistrationSessionState>()((set) => ({
    userId: readInitialUserId(),
    actions: {
        userIdAssigned: (userId) => {
            sessionStorage.setItem(USER_ID_SESSION_STORAGE_KEY, userId);
            set({ userId });
        },
        userIdCleared: () => {
            sessionStorage.removeItem(USER_ID_SESSION_STORAGE_KEY);
            set({ userId: '' });
        },
    },
}));
